import Loading from '../../../Common/Loading';
import { useSummaryChartsDataContext } from './hooks/useSummaryChartsDataContext';
import { TotalServices } from './TotalServices';
import { IdentificationIndex } from './IdentificationIndex';
import { AnnualEvolutionServices } from './AnnualEvolutionServices';
import { AnnualPercentageServices } from './AnnualPercentageServices';
import { MonthlyEvolutionServices } from './MonthlyEvolutionServices';

export const Charts = () => {
    const { isLoading } = useSummaryChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <IdentificationIndex />
                <TotalServices />
            </div>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolutionServices />
                <AnnualPercentageServices />
            </div>
            <div className="w-100">
                <MonthlyEvolutionServices />
            </div>
        </>
    );
};
